<template>
  <div>
    <div
      v-if="loader.page"
      class="d-flex justify-content-center align-items-center"
      style="min-height: 100vh !important"
    >
      <LoaderLogo :loading="true" class="m-0" />
    </div>
    <div v-else :class="`${darkMode ? 'DARK_MODE' : ''}`">
      <Header @logouted="logoutRequest" />
      <div
        class="d-flex flex-column justify-content-between"
        :style="`overflow-y: scroll !important; overflow-x: hidden !important;  min-height:100vh; max-height: 100vh`"
      >
        <router-view
          style="padding: 75px 12.5px 50px 12.5px !important"
        ></router-view>

        <Footer />
      </div>
    </div>
  </div>
</template>

<script>
import { baseMixin } from "../../libs/mixins/layouts";

export default {
  mixins: [baseMixin],
};
</script>
